import React, { useState, useCallback, useEffect } from 'react';
import VideoScrubSection from './components/VideoScrubSection';
import LeadForm from './components/LeadForm';
import LeadConfirmation from './components/LeadConfirmation';
import PhoneFrame from './components/PhoneFrame';
import { QuizOverlay, QuizContainer } from './styles/MFLancamentosStyles';

const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);
  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isDesktop;
};

const MFLancamentosContent = () => {
  const [phase, setPhase] = useState('video-quiz');
  const [answers, setAnswers] = useState({});
  const [lead, setLead] = useState(null);

  const handleAnswerCollected = useCallback((questionId, value) => {
    setAnswers(prev => ({ ...prev, [questionId]: value }));
  }, []);

  const handleQuizComplete = useCallback(() => {
    setTimeout(() => {
      setPhase('form');
    }, 500);
  }, []);

  const handleFormSubmit = useCallback((data) => {
    setLead(data);
    setPhase('confirmation');
  }, []);

  if (phase === 'video-quiz') {
    return (
      <VideoScrubSection
        onQuizComplete={handleQuizComplete}
        onAnswerCollected={handleAnswerCollected}
      />
    );
  }

  return (
    <QuizOverlay>
      <QuizContainer className="enter-right">
        {phase === 'form' && <LeadForm onSubmit={handleFormSubmit} />}
        {phase === 'confirmation' && <LeadConfirmation lead={lead} />}
      </QuizContainer>
    </QuizOverlay>
  );
};

const MFLancamentosLP = () => {
  const isDesktop = useIsDesktop();
  const isEmbedded = new URLSearchParams(window.location.search).get('embedded') === 'true';

  // Dentro do iframe ou em mobile: renderiza conteudo direto
  if (isEmbedded || !isDesktop) {
    return <MFLancamentosContent />;
  }

  // Desktop: renderiza dentro do phone frame
  const currentPath = window.location.pathname;
  return <PhoneFrame src={`${currentPath}?embedded=true`} />;
};

export default MFLancamentosLP;
